import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Chandi Ka Rate in Bangalore — 1 Tola & 10 Gram Price";
const DESC = "Live silver / chandi rate in Bangalore today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/INR FX.";

export const Route = createFileRoute("/silver-rate-bangalore")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-bangalore" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="india"
      cityName="Bangalore"
      title="Today's Live Chandi (Silver) Rate in Bangalore"
      intro="Live silver rate in Bangalore — recalculated every 10 minutes from international XAG spot price and today's USD/INR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
